<template>
  <Component
    :is="chartType"
    :chart-id="chartId"
    :chart-options="chartOptions"
    :chart-data="chartData"
    :plugins="plugins"
    :width="width"
    :height="height"
    :data-test-name="`${chartType}-chart`"
    data-test-variant=""
    data-test-state=""
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import BBarChart from './bar-chart.vue'
import BLineChart from './line-chart.vue'
import BBubbleChart from './bubble-chart.vue'
import BDonutChart from './donut-chart.vue'
import BPieChart from './pie-chart.vue'
import BPolarAreaChart from './polar-area-chart.vue'
import BRadarChart from './radar-chart.vue'
import BScatterChart from './scatter-chart.vue'
import type { PropType } from 'vue'
import type { Plugin } from 'chart.js'

defineOptions({ name: 'BChart' })

const props = defineProps({
  chartType: {
    type: String,
    default: 'bar',
  },
  chartData: {
    type: Object,
    default: () => ({}),
  },
  chartOptions: {
    type: Object,
    default: () => ({ responsive: true, maintainAspectRatio: false }),
  },
  chartId: {
    type: String,
    default: 'b-chart',
  },
  width: {
    type: Number,
    default: 400,
  },
  height: {
    type: Number,
    default: 400,
  },
  plugins: {
    type: Array as PropType<Plugin<'bar'>[]>,
    default: () => [],
  },
})

const chartType = computed(() => {
  switch (props.chartType) {
    case 'bar':
      return BBarChart
    case 'bubble':
      return BBubbleChart
    case 'donut':
      return BDonutChart
    case 'doughnut':
      return BDonutChart
    case 'line':
      return BLineChart
    case 'pie':
      return BPieChart
    case 'polar-area':
      return BPolarAreaChart
    case 'radar':
      return BRadarChart
    case 'scatter':
      return BScatterChart
    default:
      return BBarChart
  }
})
</script>
